import { useEffect } from "react";
import { scheduleIdle } from "~/utils/schedule-idle";

const TRAD_JS_SCRIPT_ID = "adcell-trad-js";
const MARKETING_SCRIPT_IDLE_TIMEOUT_MS = 3000;
const ADCELL_TRAD_JS_URL = "https://t.adcell.com/js/trad.js";
const ADCELL_BID_COOKIE = "adcell_bid";
const ADCELL_BID_MAX_AGE = 7776000; // 90 days in seconds

interface AdcellTrackingConfig {
	enabled: boolean;
}

function persistBidFromUrl(): void {
	const bid = new URLSearchParams(window.location.search).get("bid");
	if (bid) {
		const secureAttribute =
			window.location.protocol === "https:" ? "; Secure" : "";
		document.cookie = `${ADCELL_BID_COOKIE}=${encodeURIComponent(bid)}; Max-Age=${ADCELL_BID_MAX_AGE}; SameSite=Lax; Path=/${secureAttribute}`;
	}
}

function loadTradJs(): void {
	if (document.getElementById(TRAD_JS_SCRIPT_ID)) {
		return;
	}

	const script = document.createElement("script");
	script.id = TRAD_JS_SCRIPT_ID;
	script.src = ADCELL_TRAD_JS_URL;
	script.async = true;
	script.setAttribute("data-adcell", "true");
	script.onload = () => {
		window.Adcell?.Tracking.track();
	};

	document.head.appendChild(script);
}

export function useAdcellTracking({ enabled }: AdcellTrackingConfig): void {
	useEffect(() => {
		if (!enabled || typeof window === "undefined") {
			return;
		}

		persistBidFromUrl();
		return scheduleIdle(
			() => {
				loadTradJs();
			},
			{ timeout: MARKETING_SCRIPT_IDLE_TIMEOUT_MS },
		);
	}, [enabled]);
}
